<template>
	<!-- <div v-if="mresponse" class="essay">
		<p class="respText">{{mresponse.media[0].value}}</p>
	</div>-->
	<div class="px-2">
		<div v-if="!pages.length" class="essay loader" :style="{ color: themeColor + ' !important' }">
			<p class="respText">
				<loading type="icon" />
			</p>
		</div>
		<div v-for="page in pages" :key="page.id" style="page-break-after: auto;">
			<!-- <text-media v-if="page.type == 'text'" :page="page"></text-media> -->
			<TextMedia v-if="page.type == 'text'" :item="item" :page="page" :chan="chan || newChan"></TextMedia>
			<PDFMedia v-if="page.type == 'pdf'" :page="page" :chan="chan || newChan"></PDFMedia>
			<VideoMedia v-if="page.type == 'video'" :page="page"></VideoMedia>
			<AudioMedia v-if="page.type == 'audio'" :page="page"></AudioMedia>
			<ImageMedia v-if="page.type == 'image'" :page="page" :chan="chan || newChan"></ImageMedia>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import Utils from "@/services/Utils";
import ResponseMediaService from "@/services/ResponseMediaService";
import ThemeService from "@/services/ThemeService";

import PDFMedia from "@/components/viewer/PDFMedia";
import VideoMedia from "@/components/viewer/VideoMedia";
import AudioMedia from "@/components/viewer/AudioMedia";
import ImageMedia from "@/components/viewer/ImageMedia";
import TextMedia from "@/components/viewer/TextMedia";

export default {
	name: "Media",
	props: ["response", "chan", "item"],
	components: { PDFMedia, VideoMedia, ImageMedia, TextMedia, AudioMedia },
	data() {
		return {
			mresponse: _.cloneDeep(this.response),
			newChan: null,
			pages: [],
			themeColor: ThemeService.getThemeColorHex()
		};
	},

	watch: {
		response: {
			handler: function(newVal) {
				this.mresponse = _.cloneDeep(newVal);
				this.pages = [];
				this.setup();
			},
			deep: true,
			immediate: true
		}
	},

	created() {
		// console.log(this.mresponse);
		if (!this.chan) {
			this.newChan = new Vue();
		}
	},

	methods: {
		setup() {
			var _this = this;
			console.log(this.mresponse);
			var now = new Date().getTime();
			if (this.mresponse) {
				ResponseMediaService.setupResponse(this.mresponse, this.item).then(pages => {
					_this.pages = pages.map(p => {
						p.id = Math.random()
							.toString(36)
							.substr(2, 9);
						p.start = now;
						return p;
					});
					console.log("Render time:" + (new Date().getTime() - now));
					this.$emit("setup", true);
					// console.log(pages);
				});
			}
		}
	}
};
</script>

<style>
.essay {
	margin-top: 20px;
	position: relative;
	margin-left: auto;
	margin-right: auto;

	min-width: 400px;
	max-width: 800px;
	font-size: 18px;

	/*padding:80px;*/
	-webkit-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	-moz-box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	box-shadow: 3px 3px 11px 1px rgba(184, 182, 184, 1);
	background-color: white;
	color: black;
	font-family: "Times New Roman", Times, Georgia, serif;
}
.essay::before {
	content: "";
	float: left;
	width: 1px;
	margin-left: -1px;
	padding-top: 125%;
}
.essay::after {
	content: "";
	display: table;
	clear: both;
}
.essay-nopad::before {
	padding-top: 0;
}
.loader {
	font-size: 128px;
	text-align: center;
}

.essay:last-of-type {
	margin-bottom: 50px;
}

.respText {
	white-space: pre-wrap; /* css-3 */
	word-wrap: break-word; /* Internet Explorer 5.5+ */
	word-break: normal;
	padding: 80px;
}

.essaySpinner {
	height: 200px;
	width: 200px;
	margin-left: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/viewer/Media.vue